var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6415 1.92627C9.31452 2.00849 7.01085 2.89377 5.17794 4.58202L9.86779 9.27186C11.3342 7.60147 12.0048 5.11471 11.6415 1.92627ZM12.4912 1.93129C12.8496 5.26902 12.1259 8.00441 10.4651 9.86933L11.9992 11.4033L18.8204 4.58202C17.0228 2.92621 14.7724 2.04238 12.4912 1.93129ZM4.58123 5.17874C2.89293 7.01164 2.00769 9.31532 1.92548 11.6423C5.11391 12.0056 7.60063 11.335 9.27112 9.86858L4.58123 5.17874ZM19.4172 5.17874L12.5959 12L14.1292 13.5333C15.7143 12.1218 17.9284 11.3873 20.6065 11.4187C21.0794 11.4243 21.567 11.454 22.0679 11.5078C21.9568 9.22663 21.0729 6.9763 19.4171 5.17874H19.4172ZM9.86849 10.4659C8.00357 12.1266 5.26818 12.8504 1.93049 12.4919C2.04159 14.7732 2.92546 17.0236 4.58127 18.8212L11.4025 12L9.86849 10.4659ZM20.4155 12.2598C18.0131 12.2617 16.0963 12.9296 14.7273 14.1314L19.4171 18.8212C21.1054 16.9883 21.9906 14.6847 22.0729 12.3576C21.4975 12.292 20.9444 12.2594 20.4154 12.2598L20.4155 12.2598ZM11.9992 12.5967L5.17794 19.418C6.9756 21.0738 9.22598 21.9576 11.5072 22.0687C11.1488 18.731 11.8725 15.9956 13.5333 14.1307L11.9992 12.5967ZM14.1306 14.7281C12.6642 16.3985 11.9936 18.8853 12.3569 22.0737C14.6839 21.9915 16.9875 21.1062 18.8204 19.418L14.1306 14.7281Z",
    fill: "#FB1010"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67081 15L8.00604 9.18182H9.34979L10.3129 13.2244H10.3612L11.4237 9.18182H12.5742L13.6339 13.233H13.685L14.6481 9.18182H15.9918L14.3271 15H13.1282L12.0202 11.196H11.9748L10.8697 15H9.67081Z",
    fill: "#FB1010"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWicket);
export default __webpack_public_path__ + "static/media/wicket.7e529f02b55532d223801cbd1f236240.svg";
export { ForwardRef as ReactComponent };